import styled from 'styled-components';

export const CityLocationSuggestionStyles = styled.div`
  .compact .dropdown-chevron,
  .compact .suggestion-clear {
    top: 12px;
  }

  .dropdown-chevron,
  .suggestion-clear {
    display: none;
  }
`;
